<template>
    <div>
        <h1>{{$t('404.Header')}}</h1>
        <p class="mb-10 mt-6">{{$t('404.Text')}}</p> 
        <button  >
        <a class="block items-center text-lg p-2 mb-10 rounded !text-white bg-red-600 cursor-pointer hover:text-white hover:bg-grey-200" href="/">{{$t('404.Button')}}</a>
        </button>       
    </div>
</template>